import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import _ from "lodash";
import Time from "react-time-format";
class ScroollTableKoga3arz extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const { KD_all3arzKala, KD_code, KD_name, KD_draw } = value;
            const wakelRaport = KD_all3arzKala.filter((data) => {
              if (KD_name != "") {
                return data.nameofproduct.toLowerCase().startsWith(KD_name);
              } else if (KD_code != "") {
                return data.code.toString().startsWith(KD_code);
              } else {
                return data;
              }
            }).map((user, i) => {
              if (user.table.length != 0) {
                let ten = _.multiply(
                  user.table.length != 0
                    ? _.last(user.table).numberOfCarton
                    : 0,
                  0.1
                );
                return (
                  <>
                    <tr
                      key={i}
                      className="f4"
                      style={{
                        color: `${Number(user.rasidKarton) <= ten ? "red" : ""}`
                      }}
                      tabindex={KD_code == user.code ? 0 : ""}
                    >
                      <td
                        className="fk"
                        style={{ border: "2px solid #f0ad4e" }}
                      >
                        {Number(user.rasidKarton).toFixed(2)}
                      </td>
                      <td
                        className="fk"
                        style={{ border: "2px solid #f0ad4e" }}
                      >
                        {Number(
                          _.subtract(
                            user.table.length != 0
                              ? _.last(user.table).numberOfCarton
                              : 0,
                            user.rasidKarton
                          )
                        ).toFixed(2)}
                      </td>
                      <td
                        className="fk"
                        style={{ border: "2px solid #f0ad4e" }}
                      >
                        {user.table.length != 0
                          ? _.last(user.table).numberOfCarton
                          : 0}
                      </td>
                      <td
                        className="fk"
                        style={{ border: "2px solid #f0ad4e" }}
                      >
                        {user.priceOneRRR}
                      </td>
                      <td
                        className="fk"
                        style={{ border: "2px solid #f0ad4e" }}
                      >
                        {user.zhmarayDwkan}
                      </td>
                      <td
                        className="fk"
                        style={{ border: "2px solid #f0ad4e" }}
                      >
                        {user.nameofproduct}
                      </td>
                      <td
                        className="fk"
                        style={{ border: "2px solid #f0ad4e" }}
                      >
                        {" "}
                        <Time
                          value={
                            user.table.length != 0
                              ? _.last(user.table).date
                              : ""
                          }
                          format="YYYY-MM-DD"
                          style={{ color: "black" }}
                        />
                      </td>
                      <td
                        className="fk"
                        style={{ border: "2px solid #f0ad4e" }}
                      >
                        {user.code}
                      </td>
                    </tr>
                  </>
                );
              }
            });

            return (
              <div className="JM">
                <table
                  id="example"
                  className="table table-hover table-bordered text-right "
                >
                  <thead>
                    <tr
                      className="text-warning f4"
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <th style={{ border: "2px solid #f0ad4e" }}>ماوە</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>فرۆشتن</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>کڕین</th>{" "}
                      <th style={{ border: "2px solid #f0ad4e" }}>نرخی دنک</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>ژ.دووکان</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        ناوەی کاڵا
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>بەروار</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>کۆد</th>
                    </tr>
                  </thead>
                  <tbody>{wakelRaport}</tbody>
                </table>
              </div>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default ScroollTableKoga3arz;
